import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

export interface TemporaryPasswordData {
  password: string;
  username: string;
}

@Component({
  selector: 'app-temporary-password-dialog',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule, MatIconModule, MatCardModule],
  template: `
    <div class="dialog-content">
      <h2 matCardTitle>
        <mat-icon class="password-icon">key</mat-icon>
        Temporary SSO Credentials
      </h2>
      <mat-card>
        <div class="credential-row">
          <span class="credential-label">Username:</span>
          <span class="credential-value">{{ data.username }}</span>
        </div>
        <div class="credential-row">
          <span class="credential-label">Password:</span>
          <span class="credential-value password">{{ data.password }}</span>
        </div>
      </mat-card>
      <div class="actions">
        <button mat-raised-button color="primary" (click)="copyPassword()">
          <mat-icon>content_copy</mat-icon>
          {{ copied ? 'Copied!' : 'Copy Password' }}
        </button>
        <button mat-stroked-button (click)="close()">
          Close
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .dialog-content {
        padding: 24px;
        min-width: 380px;
        text-align: center;
      }

      h2 {
        margin-top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #333;
      }

      .password-icon {
        font-size: 28px;
        width: 28px;
        height: 28px;
        color: #1976d2;
      }

      mat-card {
        margin: 16px 0;
        padding: 16px;
        text-align: left;
        background: #f5f5f5;
      }

      .credential-row {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
      }

      .credential-row:last-child {
        margin-bottom: 0;
      }

      .credential-label {
        font-weight: 500;
        min-width: 80px;
        color: #555;
      }

      .credential-value {
        font-size: 16px;
        font-family: monospace;
        word-break: break-all;
      }

      .credential-value.password {
        background: #e8f5e9;
        padding: 2px 6px;
        border-radius: 4px;
      }

      .actions {
        display: flex;
        gap: 12px;
        justify-content: center;
        margin-top: 16px;
      }
    `
  ]
})
export class TemporaryPasswordDialogComponent {
  copied = false;

  constructor(
    private dialogRef: MatDialogRef<TemporaryPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TemporaryPasswordData
  ) {}

  copyPassword(): void {
    navigator.clipboard.writeText(this.data.password).then(() => {
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}